// extracted by mini-css-extract-plugin
export default {"content":"pCRwSgblBxzcErlB0LV4"};